import {Injectable, EventEmitter, Output} from '@angular/core';
import {ImageSliderComponent} from '../../../../shared/components/image/slider';
import {ModalController, Modal} from 'ionic-angular';

/**
 * Class for the ImagePreviewService
 * @class
 */
@Injectable()
export class ImagePreviewService {

  @Output()
  onDismiss: EventEmitter<any> = new EventEmitter();

  items: any[] = [];

  modal: Modal;

  /**
   * @constructor
   * @param {ModalController} modalCtrl
   */
  constructor(public modalCtrl: ModalController) {
  }

  /**
   * Shows the slider modal
   * @param {number} index index in the items list
   * @returns {Promise<any>}
   */
  showPreview(index: number): Promise<any> {
    this.modal = this.modalCtrl.create(ImageSliderComponent, {images: this.items, index, showSelect: false}, {
      cssClass: 'image-preview-modal',
      enableBackdropDismiss: true,
      showBackdrop: true,
    });

    this.modal.onDidDismiss((val) => this.onDismiss.emit(val));

    return this.modal.present();
  }

}


// WEBPACK FOOTER //
// ./src/app/content/shared/services/image-preview/image-preview.service.ts